import React, {useEffect, useState } from "react"

import { Header } from "./Header";
import { Footer } from "./Footer";


export const Page = ({
    xumm=null,
    runtime=null, 
    children}) => {

    return (
        <div className="flex flex-col h-fit min-h-screen justify-between">
            <Header xumm={xumm} runtime={runtime} />
            <main className="mb-auto h-full bg-slate-800">{children}</main>
            <Footer />
        </div>
    );
};